import { CONSTANTS } from '@/types/enum/constants'

const getIsUserTeamsPreparateur = (loggedUserRoles: string[]): boolean =>
  !!loggedUserRoles?.find(value => value == CONSTANTS.ROLE_PREPARATEUR) || false

export default getIsUserTeamsPreparateur
